module.exports = __webpack_public_path__ + "img/hr-tree-01-f-leaves.88f25f85.png";